import { reactive } from 'vue';

// Lightweight pub/sub event bus for cross-component communication outside the
// props/emit chain. Reactive so consumers can observe `events` if needed.
const eventBus = reactive({
  events: {},
  /**
   * Invokes all callbacks registered for the given event, passing them the payload.
   *
   * @param {string} event - The event name to emit
   * @param {*} [payload] - Data to pass to each registered callback
   * @returns {void}
   */
  emit(event, payload) {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback(payload));
    }
  },
  /**
   * Registers a callback to be invoked whenever the given event is emitted.
   *
   * @param {string} event - The event name to listen for
   * @param {Function} callback - The function to call when the event fires
   * @returns {void}
   */
  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  },
  /**
   * Removes a previously registered callback for the given event.
   *
   * @param {string} event - The event name to unsubscribe from
   * @param {Function} callback - The exact callback reference to remove
   * @returns {void}
   */
  off(event, callback) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    }
  }
});

export default eventBus;
